import * as api from '../api';
import { formatDate, getCdnImageUrl } from "../functions";
import {getCustomerEmail, getCustomerGuid} from "../customer";
import { Modal } from "../mySubscription/modal";

if ($('body').hasClass('in-nastaveni')) {

	showSpinner();

	api.getData(
		'get-children',
		{ guid: getCustomerGuid() },
		{ async: false }
	).done(function(data) {
		var items = '';

		data.forEach(function(child) {
		items += `<tr>
	                                                <td>
	                                                    ${child.name}
	                                                </td>
	                                                <td>
	                                                   ${child.dateBirth ? formatDate(child.dateBirth) : '-'} 
	                                                </td>
	                                               
	                                                    <td>
	                                                        <a href="#" title="Smazat položku" data-id="${child.id}" class="delete-child hide-on-mouseout shoptet-icon">Smazat</a>
	                                                    </td>
	                                                                                            </tr>`;
		})

		var children = `<fieldset class="f-border checkout-single-box">
	                        <legend>Moje děti</legend>
	                        <div class="f-border-in">
	                                                            <table class="table-customer-section-workaround table-customer-section table-column-12">
	                                    <tbody>
	                                                                                    ${items}
	                                                                            </tbody>
	                                </table>
	                            
	                            <p class="top-2rem">
	                                <a href="#" class="add-child" title="Přidat nové dítě">
	                                    Přidat dítě                                </a>
	                            </p>
	                        </div>
	                    </fieldset>`;

		children += Modal(`<div id="addChild" style="display: block">
	                <div class="sub-order-box">
	                    <button  type="button" class="sub-exit"><img src="${getCdnImageUrl(`/user/documents/upload/subimg/cross.svg`)}"></button>
	                    <h3>Přidání dítěte</h3>
	                    <form action="#" method="POST" id="add-child-form">
	                        <input id="sub-add-name" required="required" type="text" placeholder="Jméno">
	                        <div class="sub-add-date">
	                            <label>
	                              <span>Datum narození</span>
	                              <input id="sub-add-date" type="date" placeholder="Datum narození">
	                            </label>
	                            <p>Proč potřebujeme datum narození<span class="sub-tooltip">Rádi bychom, aby vaše předplatné bylo miminku šité na míru. Pokud například nějaký produkt bude nedostupný, nabídneme vám relevantní náhradu.</span></p>
	                        </div>
	                        <button type="submit" id="subscription-confirm-child" class="subscription-button">Přidat dítě</button>
	                    </form>
	                </div>     
	            </div>`, 'add-child-modal')

		$('.checkout-single-box:nth-child(3)').after(children);
		hideSpinner();
	});



	$(document).on('click', '.add-child', function (e) {
		e.preventDefault();
		$('.add-child-modal').show();
	})


	$(document).on('click', '.delete-child', function (e) {
		e.preventDefault();
		var $this = $(this);
		showSpinner();
		api.getData(
			'remove-child',
			{ guid: getCustomerGuid(), childId: $this.data('id') },
		).done(function () {
			hideSpinner();
			$this.closest('tr').remove();
		}).fail(function() {
			hideSpinner();
			alert("Dítě nemůže být smazáno jelikož má již vytvořené předplatné.");
		});
	})

	$(document).on('click', '.add-child-modal #subscription-confirm-child', function (e) {
		e.preventDefault();
		var form = $(this).closest('form');
		var name = form.find('#sub-add-name').val();
		var email = getCustomerEmail();
		var birthDate = form.find('#sub-add-date').val() || null;
		if(!name){
			alert("Zadejte jméno dítěte");
			return;
		}
		showSpinner();
		api.postData(
			'insert-child',
			{name, email, birthDate},
			{ guid: getCustomerGuid() },
		).done(function (data) {
			window.location.reload();
			// hideSpinner();
		})
	})
}



